import React from "react";
// nodejs library that concatenates classes
// import classNames from "classnames";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import CircularProgress from "@material-ui/core/CircularProgress";

import settingsStyles from "assets/jss/material-kit-pro-react/views/gSettingsStyle.js";

// @material-ui/icons

// core components
import Pay from "@material-ui/icons/Payment";

import Input from "components/GCustomInput/CustomInput.js";

import axios from "axios";
import Config from "config";

import SnackbarContent from "components/GSnackbar/SnackbarContent.js";

import Brightness1 from "@material-ui/icons/Brightness1";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { LinearProgress, Typography, Box } from "@material-ui/core";

import zxcvbn from "zxcvbn";
import { secureStorage } from "libs";

const styles = (theme) => ({
  ...settingsStyles,
  buttons: {
    marginTop: "25px",
  },
  progress: {
    height: 10,
    borderRadius: 5,
  },
  error: {
    backgroundColor: "#f44336", // red
  },
  warning: {
    backgroundColor: "#ff9800", // orange/yellow
  },
  success: {
    backgroundColor: "#4caf50", // green
  },
  inlineRule: {
    display: "inline-flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  valid: {
    color: "green",
  },
  invalid: {
    color: "red",
  },
  icon: {
    fontSize: 18,
    marginRight: 4,
  },
});

const rules = [
  { label: "Min. 10 karakter" },
  { label: "Huruf besar" },
  { label: "Huruf kecil" },
  { label: "Angka" },
  { label: "Simbol (@#$!)" },
];

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPass: "",
      newPass: "",
      rePass: "",
      showPassword: false,
      buttonPassDisabled: false,

      snackBar: false,
      snackMessage: "",
      snackColor: "danger",

      score: 0,
      progressValue: 0,
      strengthText: ["Very Weak", "Weak", "Fair", "Good", "Strong"],
      buttonDisabled: true,
    };
  }

  componentDidMount() {}

  getBarColor = (classes) => {
    if (this.state.score <= 1) return classes.error;
    if (this.state.score <= 3) return classes.warning;
    return classes.success;
  };

  handleChangePass = (e) => {
    // this.setState({ [e.target.id]: e.target.value });
    if (e.target.id === "newPass") {
      const score = zxcvbn(e.target.value).score;
      const progressValue = ((score + 1) / 5) * 10;

      this.setState({
        newPass: e.target.value,
        score,
        progressValue,
        buttonDisabled: score === 4 ? false : true,
      });
    } else {
      this.setState({ [e.target.id]: e.target.value });
    }
  };
  handleAlertExit = () => {
    this.setState({ snackBar: false });
  };
  handleSubmitChangePass = (e) => {
    if (!this.state.oldPass && !this.state.newPass && !this.state.rePass) {
      this.setState({
        snackBar: true,
        snackColor: "danger",
        snackMessage: "Semua field harus diisi !",
      });
    } else if (this.state.newPass !== this.state.rePass) {
      this.setState({
        snackBar: true,
        snackColor: "danger",
        snackMessage: "Password dan Re-type passwod harus sama !",
      });
    } else {
      const account = secureStorage.getItem("account");
      const endpoint =
        account && account.LoginUsers
          ? "user/changepass/lu"
          : "user/changepass";

      axios
        .post(Config.backendUrl + endpoint, {
          oldPass: this.state.oldPass,
          newPass: this.state.newPass,
        })
        .then((res) => {
          this.setState({
            snackBar: true,
            snackColor: "success",
            snackMessage: res.data,
          });
        })
        .catch((error) => {
          if (error.response) {
            this.setState({
              snackBar: true,
              snackColor: "danger",
              snackMessage: error.response.data,
            });
          }
        });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.grid}>
            {this.state.snackBar ? (
              <SnackbarContent
                message={<span>{this.state.snackMessage}</span>}
                onExited={this.handleAlertExit}
                close
                color={this.state.snackColor}
                icon="info_outline"
              />
            ) : null}
            <Input
              labelText="Password Lama"
              id="oldPass"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: this.state.oldPass,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                      }
                    >
                      {this.state.showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
                type: this.state.showPassword ? "text" : "password",
                //autoComplete: "off",
                onChange: this.handleChangePass,
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.grid}>
            <Input
              labelText="Password Baru"
              id="newPass"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: this.state.showPassword ? "text" : "password",
                value: this.state.newPass,
                //autoComplete: "off",
                onChange: this.handleChangePass,
              }}
            />

            <Box mt={2}>
              <Typography variant="subtitle2" gutterBottom>
                Aturan Password:
              </Typography>
              <Box display="flex" flexWrap="wrap">
                {rules.map((rule, index) => {
                  return (
                    <Box key={index} className={classes.inlineRule}>
                      <Brightness1 className={`${classes.icon}`} />
                      <Typography variant="body2">{rule.label}</Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            {this.state.newPass && (
              <>
                <Box mt={2}>
                  <LinearProgress
                    variant="determinate"
                    value={this.state.progressValue * 10}
                    classes={{
                      root: classes.progress,
                      barColorPrimary: this.getBarColor(classes),
                    }}
                    color="primary"
                  />
                </Box>
                <Typography variant="body2" style={{ marginTop: 8 }}>
                  Strength:{" "}
                  <strong>{this.state.strengthText[this.state.score]}</strong>
                </Typography>
              </>
            )}
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.grid}>
            <Input
              labelText="Konfirmasi Password"
              id="rePass"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: this.state.showPassword ? "text" : "password",
                value: this.state.rePass,
                //autoComplete: "off",
                onChange: this.handleChangePass,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={8} className={classes.grid}>
            {!this.state.buttonPassDisabled ? (
              <Button
                id="changePass"
                color="instagram"
                round
                disabled={this.state.buttonDisabled}
                onClick={this.handleSubmitChangePass}
              >
                <Pay />
                Submit
              </Button>
            ) : (
              <CircularProgress color="secondary" />
            )}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}
ChangePassword.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(withStyles(styles)(ChangePassword));
